import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { selectCurrentAdmin } from '../../+state/platform-identity/platform-identity.selectors';
import { PlatformAuthService } from '../services/platform-auth/platform-auth.service';

export const platformAdminGuard: CanActivateFn = async (_route, state) => {
  const store = inject(Store);
  const router = inject(Router);
  const platformAuthService = inject(PlatformAuthService);

  try {
    // Wait for Firebase auth (and the validate round-trip) to settle.
    await platformAuthService.initializeAuthState();

    return new Promise<boolean>((resolve) => {
      store
        .select(selectCurrentAdmin)
        .pipe(take(1))
        .subscribe((admin) => {
          if (admin) {
            resolve(true);
          } else {
            router.navigate(['/welcome'], {
              queryParams: { redirectUrl: state.url },
            });
            resolve(false);
          }
        });
    });
  } catch {
    router.navigate(['/welcome'], { queryParams: { redirectUrl: state.url } });
    return false;
  }
};
